import Splide from '@splidejs/splide';

export default () => {
	if (!document.querySelector('.Carousel')) {
		return;
	}
	new Splide('.Carousel', {
    type: 'loop',
		arrows: false,
		pagination: false,
    autoplay: true,
    interval: 4000,
    speed : 600,
	}).mount();
};



// WEBPACK FOOTER //
// ./assets/src/js/modules/Carousel.js